jQuery(document).ready(function () {
    var modal = jQuery('#newsModal');
    if (modal[0]) {
        modal.foundation('open');
    }
});